import MultipleFilterableAttributes from "component/product/extended-definition/MultipleFilterableAttributes";
import WheelTireExtendedDescription from "component/product/extended-definition/WheelTireExtendedDescription";

const WheelTireHighlights = (props) => {
  const { product } = props;
  return (
    <div>
      <MultipleFilterableAttributes filterableAttributes={product.filterableAttributes} iconSize={35} />
      <WheelTireExtendedDescription
        filterableAttributes={product.filterableAttributes}
        season={product.filterableAttributes?.season}
        iconSize={35}
      />
    </div>
  );
};

export default WheelTireHighlights;
